import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Drawer from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Drawer';
import MenuIcon from '@material-ui/icons/Menu';
import { MenuOpen } from '@material-ui/icons';
import Button from 'Components/UI/Button';
import { useNewNavbarContext } from 'Components/UI/Navigation/NewNavbar/NewNavbarContext';
import ClickAwayListener from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ClickAwayListener';

// TODO: navbar structural styling & drawer functionality
const styles = (theme) => ({
  root: {},
  drawerPaper: {
    borderTopRightRadius: theme.radius.sm,
    borderBottomRightRadius: theme.radius.sm,
    height: '100vh',
    width: '90%',
    minWidth: 80,
    maxWidth: 380,
    boxShadow: theme.shadows[4],
    backgroundColor: theme.palette.facet.backgroundGray,
    display: 'flex',
    padding: theme.spacing(2),
  },
  icon: {
    color: theme.palette.facet.primaryGray,
    // TODO: padding?
  },
  drawer: {
    width: '90%',
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: '90%',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  menu: {
    width: 48,
    height: 48,
  },
});

const NewNavbarDrawer = ({
  className,
  classes,
  children,
  MenuButtonProps,
}) => {
  const { isOpen, toggleOpen, close } = useNewNavbarContext();

  const MenuIconComponent = isOpen ? MenuOpen : MenuIcon;

  return (
    <ClickAwayListener onClickAway={close}>
      <Drawer
        variant="permanent"
        className={classNames(classes.drawer, {
          [classes.drawerOpen]: isOpen,
          [classes.drawerClose]: !isOpen,
        })}
        classes={{
          paper: classNames({
            [classes.drawerOpen]: isOpen,
            [classes.drawerClose]: !isOpen,
          }),
        }}
        anchor="left"
        PaperProps={{ className: classes.drawerPaper }}
      >
        <Button
          className={classes.menu}
          variant="icon"
          onClick={toggleOpen}
          {...MenuButtonProps}
        >
          <MenuIconComponent
            className={classes.icon}
          />
        </Button>
        <Box
          className={classNames(classes.root, className)}
        >
          {children}
        </Box>
      </Drawer>
    </ClickAwayListener>
  );
};

NewNavbarDrawer.defaultProps = {
  className: '',
  MenuButtonProps: {},
};

NewNavbarDrawer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  MenuButtonProps: PropTypes.object,
};

export default withStyles(styles)(NewNavbarDrawer);
